<template>
    <LoadingState v-if="loading" overlay :zIndex="1100"></LoadingState>
    <div v-if="latestViewedGraphs.length > 0"
        class="mb-4">
         <div class="flex items-center mb-2">
            <div class="text-2xl font-semibold leading-snug tracking-tight text-gray-900 mr-4">Recently opened graphs</div>
        </div>
        <div class="flex gap-3">
            <Card v-for="graph in latestViewedGraphs" class="w-64 cursor-pointer h-20 latestCard" :key="graph.id" @click="openGraph(graph)">
                <template #title>
                    <div class="flex items-center gap-2" v-tooltip="graph.name">
                        <i class="pi pi-sitemap text-gray-600"/>
                        <span class="font-medium truncate" style="max-width: 150px;">{{ graph.name }}</span>
                    </div>
                </template>
            </Card>

        </div>

    </div>
    <div class="bg-surface-0 dark:bg-surface-950 pb-8 pt-4 flex flex-col md:flex-row md:items-center md:justify-between">
        <div class="flex items-center">
            <div class="text-2xl font-semibold leading-snug tracking-tight text-gray-900 mr-4">Processes</div>
        </div>
        <div class="flex items-center mt-4 md:mt-0">
            <Button type="button" label="Add Process" icon="pi pi-plus" rounded data-cy="add-workspace"
                @click="openConfirmation" />
        </div>
    </div>
    <ConfirmPopup group="deleteWorkspace"></ConfirmPopup>
    <WorkspaceDialog v-model="displayConfirmation"/>

    <div class="flex flex-col gap-2" :key="spaceId">
        <TreeNodeCard
            v-for="node in graphTree"
            :key="node.id"
            :node="node"
            :depth="0"
            :selected-space-id="parseInt(spaceId)"
        />
    </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import TreeNodeCard from './TreeNodeCard.vue';
import {WORKSPACE_API_TYPE, GRAPH_API_TYPE} from "@/src/model/apiTypes";
import {useStore} from 'vuex'
import WorkspaceDialog from "@/src/views/repo/WorkspaceDialog.vue";

const store = useStore();

const graphTree = computed(() => store.state.repoStore.graphTree)

const loading = computed(() => store.getters.isLoading([
    WORKSPACE_API_TYPE.GET_WORKSPACES,
    GRAPH_API_TYPE.DELETE_GRAPH,
    GRAPH_API_TYPE.RUN_JOBS
]))

const latestViewedGraphs = computed(() => {
    const storageKey = 'latestViewedGraphs'
    let graphIds = JSON.parse(localStorage.getItem(storageKey)) || [];
    return graphIds.map(id => graphMap.value.get(parseInt(id))).filter(graph => graph !== undefined);
});

// used in router to trigger expansion of the tree
const props = defineProps({
    spaceId: {
    }
});

const displayConfirmation = ref(false);

const openConfirmation = () => {
    displayConfirmation.value = true;
};

const graphMap = computed(() => store.state.repoStore.graphMap)

const openGraph = async (graph) => {
    await store.dispatch('repoStore/setSelectedGraph', graph)
}




</script>
<style scoped>
.latestCard {
    height: 60px;
}

</style>